import React, { useContext, useEffect, useState } from 'react'
import { RequestContext } from '../../../../context/RequestContext';
import { openModal } from '../../../../service/modal-service';
import { BookingCard, BookingFooter, PriceTileGrid, ServiceTypeTabs, getServiceTheme } from './AirconBookingLayout';

// Same layout as AirconBooking. The tab value doubles as the AirconScope
// serviceType key (gasRefill / gasRefillHalf), so the selected tab drives
// the tile colours and the Service Details sheet together.
const GAS_TABS = [
    { value: 'gasRefill', label: ['Full Tank', 'Refill'], ariaLabel: 'Select full tank gas top up' },
    { value: 'gasRefillHalf', label: ['Half Tank', 'Refill'], ariaLabel: 'Select half tank gas top up' },
]

// Criteria value for "Quantity of gas for refill" per tab.
const GAS_QUANTITY = {
    gasRefill: 'Full tank refill',
    gasRefillHalf: 'Not sure',
}

export const AirconGasBooking = (props) => {
    const setRequestForm = props.setRequestForm
    const setIsQuickBook = props.setIsQuickBook
    const setIsCustomBook = props.setIsCustomBook
    const setIsShowAirconItemSelection = props.setIsShowAirconItemSelection
    const showJobScope = props.showJobScope
    const gasRefillCosts = props.gasRefillCosts
    const currencyCd = props.currencyCd
    const title = props.title
    const subtitle = props.subtitle

    const [ serviceType, setServiceType ] = useState(props.serviceType || 'gasRefill')
    const unitType = 'Outdoor'
    const { setRequestCriteria, setRequestDescription, setServiceSummary } = useContext(RequestContext);

    const quickBook = (compressorCount) => {
        const criteria = [
            {1: 'Gas top up only', criteria: 'Type of service - Gas top up only'},
            {27: compressorCount.toString(), criteria: "Number of condensers for gas refill - " + compressorCount},
            {22: GAS_QUANTITY[serviceType], criteria: 'Quantity of gas for refill - ' + GAS_QUANTITY[serviceType]},
            {26: 'Not sure', criteria: 'Gas type - Not sure'}
        ]
        setRequestCriteria(criteria)
        setRequestDescription('Aircon Service')
        setIsQuickBook(true)
        // A quick book is not a custom (picker) booking, whatever came before
        setIsCustomBook(false)
        openModal(setRequestForm)
    }

    useEffect(() => {
        setRequestCriteria([])
        setRequestDescription('')
        setServiceSummary('')
        setIsQuickBook(false)
        setIsCustomBook(false)
    }, [setIsQuickBook, setRequestCriteria, setRequestDescription, setServiceSummary, setIsCustomBook])

    const theme = getServiceTheme(serviceType)

    const tiles = gasRefillCosts
        .filter(d => d.serviceType === serviceType)
        .map(item => ({
            key: `${serviceType}-${item.unit}`,
            label: `${item.unit} Compressor${item.unit > 1 ? 's' : ''}`,
            currencyCd: currencyCd,
            price: Number(item.cost).toFixed(2),
            ariaLabel: `Book gas refill for ${item.unit} compressor unit${item.unit > 1 ? 's' : ''}`,
            onBook: () => quickBook(item.unit),
        }))

  return (
    <BookingCard title={title} subtitle={subtitle}>
        <ServiceTypeTabs options={GAS_TABS} value={serviceType} onChange={setServiceType} />

        {/* Booking buttons */}
        <div className='pt-4 pb-2 px-4'>
            <PriceTileGrid
                tiles={tiles}
                theme={theme}
                onMore={() => setIsShowAirconItemSelection(true)}
            />
            <BookingFooter
                theme={theme}
                serviceType={serviceType}
                onShowDetails={() => showJobScope(serviceType, unitType)}
                highlights={['60 days warranty', 'Transport Included']}
            />
        </div>
    </BookingCard>
  )
}
